import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'change-billling-name',
  templateUrl: './change-billling-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    ErrorMsgComponent,
    TranslateModule
  ]
})
export class ChangeBilllingNameComponent implements OnInit {
  @Input('visible') showModel = false;
  @Input('removeName') removeBillingname = false;
  @Output() closeChangeBillingNameDialogEvent : EventEmitter<{hidePopup: boolean;billingName: string}>  = new EventEmitter();

  billingNameForm: UntypedFormGroup = new UntypedFormGroup({ billing_name: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]) });

  constructor() { }

  ngOnInit(): void {
    if(this.removeBillingname)
    {
      this.removeBillingName();
    }
  }

  get billingNameFormControl(): UntypedFormControl {
    return this.billingNameForm.controls.billing_name as UntypedFormControl;
  }

  removeBillingName() {
    this.billingNameFormControl.setValue('');
  }

  ClosePopup()
  {
    this.showModel = false;
    this.closeChangeBillingNameDialogEvent.emit({hidePopup:this.showModel, billingName:this.billingNameFormControl.value});
  }

}
